import React from 'react';
import PropTypes from 'prop-types';

import {Orientation} from '../../constants/dataEnum';

import './LabwareBox.scss';

const LabwareBox = React.forwardRef(({children, style, orientation, isCustomTips}, ref) => (
  <div
    ref={ref}
    className={`labware-box ${orientation.toLowerCase()} ${isCustomTips ? 'no-clip-path' : ''}`}
    style={style}
  >
    <div className={`labware-box-inner ${orientation.toLowerCase()} ${isCustomTips ? 'no-clip-path' : ''}`}>
      {children}
    </div>
  </div>
));

LabwareBox.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  orientation: PropTypes.string,
  isCustomTips: PropTypes.bool,
};

LabwareBox.defaultProps = {
  children: null,
  style: {},
  orientation: Orientation.POTRAIT,
  isCustomTips: false,
};

export default LabwareBox;
